import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dropdown, Loader, Grid, Message} from 'semantic-ui-react';
import _ from 'lodash';
import PermissionsUtility from 'go/security/permissionsUtility';
import UserSessionData from 'go/actions/userSessionData';
import REST from 'go/requests/rest';
import {filterByEntityType} from 'common/utils';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';

export class OrganizationDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOrgId: null,
    };
  }
  componentDidMount() {
    const {token, setSubAppOrgIds, setSuborgsAllowed} = this.props;

    if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
      this.getOrganizations(setSubAppOrgIds, setSuborgsAllowed);
    } else {
      let permissionData = new PermissionsUtility(token);
      permissionData.getSubAppOrgIds(token).then((res) => {
        setSubAppOrgIds(res);
        if (_.includes(res, _.parseInt(this.props.orgId))) {
          setSuborgsAllowed(true);
        }
        this.getOrganizations(null, null);
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {orgId, defaultValue, subAppOrgIds, setSuborgsAllowed} = this.props;

    if (this.state.selectedOrgId !== defaultValue) {
      this.setState({
        selectedOrgId: this.props.defaultValue,
        rederType: this.props.rederType,
      });
    }

    if (orgId !== prevProps.orgId) {
      if (
        _.includes(this.props.toggles, 'manageTeamOrgSubOrg')
          ? _.includes(subAppOrgIds, orgId)
          : _.includes(subAppOrgIds, _.parseInt(orgId))
      ) {
        setSuborgsAllowed(true);
      } else {
        setSuborgsAllowed(false);
      }
    }
  }

  handleChange = (e, res) => {
    this.setState({selectedOrgId: res.value});
    this.props.handleOrgChange(res.value);
  };

  getOrganizations = (setSubAppOrgIds, setSuborgsAllowed) => {
    REST.user
      .getEntities(this.props.token)
      .then((response) => {
        if (response.ok) {
          // TODO, refactor to use REST.handler.handleRequest and go to handleError in a promise error handler
          return response.json();
        } else {
          this.props.handleError(true);
          return [];
        }
      })
      .then((res) => {
        const filteredEntities = filterByEntityType(
          res,
          parseInt(ENTITY_MAP.PANEL_REVIEW.code)
        );
        if (_.includes(this.props.toggles, 'manageTeamOrgSubOrg')) {
          let subAppOrgIds = [];
          let orgCanHaveSubOrganizations = [];
          _.forEach(
            // _.filter(filteredEntities, ['canHaveSuborganizations', true]),
            filteredEntities,
            (obj) => {
              subAppOrgIds.push(obj.entityId);
              orgCanHaveSubOrganizations.push(obj);
            }
          );
          setSubAppOrgIds(subAppOrgIds);
          if (_.includes(subAppOrgIds, this.props.orgId)) {
            setSuborgsAllowed(true);
          }
          location.pathname === '/suborganizations'
            ? this.setData(_.sortBy(orgCanHaveSubOrganizations, 'displayName'))
            : this.setData(_.sortBy(filteredEntities, 'displayName'));
        } else {
          this.setData(_.sortBy(filteredEntities, 'displayName'));
        }
      });
  };
  setData = (res) => {
    const {
      defaultValue,
      handleOrgChange,
      setDefaultOrg,
      defaultOrgNumber,
      subAppOrgIds,
      location,
    } = this.props;

    let displayOrg = defaultValue ? defaultValue : res.length ? res[0].entityId : null;
    if (!defaultOrgNumber) {
      setDefaultOrg(displayOrg);
    }

    handleOrgChange(displayOrg ? displayOrg : null);

    if (res.length > 1) {
      const dunsToUEIToggle = _.includes(this.props.toggles, 'dunsToUEI');
      const options = _.chain(res)
        .filter((org) => {
          if (location.pathname === '/suborganizations') {
            return _.includes(this.props.toggles, 'manageTeamOrgSubOrg')
              ? _.includes(subAppOrgIds, org.entityId)
              : _.includes(subAppOrgIds, _.parseInt(org.entityId));
          }
          return org;
        })
        .map((entry) =>
          dunsToUEIToggle
            ? {
                value: entry.entityId,
                text:
                  entry.displayName +
                  (entry.uei
                    ? ' ' +
                      entry.uei +
                      (!_.isEmpty(_.trim(entry.eft)) ? '-' + entry.eft : '')
                    : ''),
                key: entry.entityId,
              }
            : {
                value: entry.entityId,
                text: entry.displayName,
                key: entry.entityId,
              }
        )
        .value();
      this.setState({options: options});
    }
    this.setState({
      orgsList: res,
      loading: false,
      selectedOrgId: displayOrg,
    });
  };

  render() {
    let {orgsList, selectedOrgId} = this.state;
    const {toggles} = this.props;
    const dunsToUEIToggle = _.includes(toggles, 'dunsToUEI');

    if (orgsList) {
      if (orgsList.length === 0) {
        return (
          <Message
            negative
            icon="exclamation"
            header="You must first belong to an organization to see organization information."
          />
        );
      } else if (orgsList.length === 1) {
        return dunsToUEIToggle ? (
          <React.Fragment>
            <h2>
              {orgsList[0].displayName +
                (orgsList[0].uei
                  ? !_.isEmpty(_.trim(orgsList[0].eft))
                    ? ' ' + orgsList[0].uei + '-' + orgsList[0].eft
                    : ' ' + orgsList[0].uei
                  : '')}
            </h2>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <h2>{orgsList[0].displayName}</h2>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <label for="orgSelect" className="sr-only">
              Select an organization
            </label>
            <Dropdown
              value={selectedOrgId}
              options={this.state.options}
              id={'orgSelect'}
              onChange={this.handleChange}
              className="select-org-dropdown"
              title="Organization dropdown"
            />
            <p aria-hidden="true" className="select-label">
              Select an organization
            </p>
          </React.Fragment>
        );
      }
    } else {
      return (
        <Grid centered>
          <Grid.Row>
            <Grid.Column>
              <Loader inline="centered" active>
                Loading...
              </Loader>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    orgId: state.userSessionData.orgId,
    subAppOrgIds: state.userSessionData.subAppOrgIds,
    defaultOrgId: state.userSessionData.defaultOrgId,
    location: state.router.location,
    suborgsAllowed: state.userSessionData.suborgsAllowed,
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  setSubAppOrgIds: (res) => {
    dispatch(UserSessionData.setSubAppOrgIds(res));
  },
  setSuborgsAllowed: (bool) => {
    dispatch(UserSessionData.setSuborgsAllowed(bool));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationDropdown);
